export const COMPONENTSETTINGS = [
  {
    componentName: 'IdeComp',
    configStyle: [
      {
        id: 'readOnly',
        value: 'false'
      },
      {
        id: 'lineNumber',
        value: 'true'
      },
      {
        id: 'autoCompletion',
        value: 'false'
      },
      {
        id: 'autoGrow',
        value: 'true'
      }
    ]
  },
  {
    componentName: 'OutputComp',
    configStyle: [
      {
        id: 'autoGrow',
        value: 'true'
      },
      {
        id: 'fontSize',
        value: '12'
      }
    ]
  },
  {
    componentName: 'LanguagesListComp',
    configStyle: [
      {
        id: 'hideTitle',
        value: 'true'
      },
      {
        id: 'titleName',
        value: 'Select Language:'
      },
      {
        id: 'display',
        value: 'true'
      }
    ]
  },
  {
    componentName: 'VersionListComp',
    configStyle: [
      {
        id: 'hideTitle',
        value: 'true'
      },
      {
        id: 'titleName',
        value: 'Select Version:'
      },
      {
        id: 'display',
        value: 'false'
      }
    ]
  },
  {
    componentName: 'stdinArgs',
    configStyle: [
      {
        id: 'hideTitle',
        value: 'true'
      },
      {
        id: 'titleName',
        value: 'STDIN Input:'
      },
      {
        id: 'display',
        value: 'false'
      },
      {
        id: 'lines',
        value: '2'
      }
    ]
  },
  {
    componentName: 'inputArgs',
    configStyle: [
      {
        id: 'hideTitle',
        value: 'true'
      },
      {
        id: 'titleName',
        value: 'Input Arguments:'
      },
      {
        id: 'display',
        value: 'false'
      },
      {
        id: 'lines',
        value: '2'
      }
    ]
  },
  {
    componentName: 'interactiveToggle',
    configStyle: [
      {
        id: 'hideTitle',
        value: 'true'
      },
      {
        id: 'titleName',
        value: 'Interactive Mode:'
      },
      {
        id: 'display',
        value: 'true'
      }
    ]
  },
  {
    componentName: 'LibsComp',
    configStyle: [
      {
        id: 'canEdit',
        value: 'true'
      }
    ]
  },
  {
    componentName: 'InputFileComp',
    configStyle: [
      {
        id: 'canUpload',
        value: 'true'
      }
    ]
  },
  {
    componentName: 'OutputFileComp',
    configStyle: []
  },
  {
    componentName: 'ExeMatrix',
    configStyle: [
      {
        id: 'hideTitle',
        value: 'true'
      },
      {
        id: 'titleName',
        value: 'Execution Matrices:'
      },
      {
        id: 'display',
        value: 'true'
      }
    ]
  },
  {
    componentName: 'fontSize',
    configStyle: [
      {
        id: 'hideTitle',
        value: 'true'
      },
      {
        id: 'titleName',
        value: 'Editor Font Size:'
      },
      {
        id: 'display',
        value: 'true'
      }
    ]
  },
  {
    componentName: 'executeBtn',
    configStyle: []
  },
  {
    componentName: 'postToJdoodle',
    configStyle: []
  }
]
export const CONFIG = {
  assets: [],
  styles: [
    {
      selectors: ['#id4q'],
      style: {
        hideTitle: 'true'
      },
      mediaText: '(max-width: 1024px)',
      atRuleType: 'media'
    },
    {
      selectors: ['#i3ar'],
      style: {
        color: 'black'
      },
      mediaText: '(max-width: 1024px)',
      atRuleType: 'media'
    },
    {
      selectors: ['#i5xj'],
      style: {
        autoGrow: 'true',
        height: '384px'
      },
      mediaText: '(max-width: 1024px)',
      atRuleType: 'media'
    },
    {
      selectors: ['#ip43'],
      style: {
        autoGrow: 'true',
        height: '128px'
      },
      mediaText: '(max-width: 1024px)',
      atRuleType: 'media'
    }
  ],
  pages: [
    {
      frames: [
        {
          component: {
            type: 'wrapper',
            stylable: [
              'background',
              'background-color',
              'background-image',
              'background-repeat',
              'background-attachment',
              'background-position',
              'background-size'
            ],
            attributes: {
              id: 'ieqb'
            },
            components: [
              {
                name: 'fontSize',
                resizable: true,
                content: '<div id="fontSize"></div>'
              },
              {
                name: 'IdeComp',
                droppable: false,
                resizable: true,
                content: '<div id="IdeComp"></div>',
                attributes: {
                  id: 'i5xj'
                },
                commands: ['select-parent', 'move', 'delete', 'show-style-manager']
              },
              {
                name: 'VersionListComp',
                droppable: false,
                resizable: true,
                content: '<div id="VersionListComp"></div>',
                attributes: {
                  id: 'iyal'
                },
                commands: ['select-parent', 'move', 'delete', 'show-style-manager']
              },
              {
                name: 'stdinArgs',
                droppable: false,
                resizable: true,
                content: '<div id="stdinArgs"></div>',
                attributes: {
                  id: 'id4q'
                },
                commands: ['select-parent', 'move', 'delete', 'show-style-manager']
              },
              {
                name: 'inputArgs',
                droppable: false,
                resizable: true,
                content: '<div id="inputArgs"></div>',
                commands: ['select-parent', 'move', 'delete', 'show-style-manager']
              },
              {
                name: 'interactiveToggle',
                droppable: false,
                resizable: true,
                content: '<div id="interactiveToggle"></div>',
                commands: ['select-parent', 'move', 'delete', 'show-style-manager']
              },
              {
                name: 'executeBtn',
                droppable: false,
                resizable: true,
                content: '<div id="executeBtn"></div>',
                attributes: {
                  id: 'i3ar'
                },
                commands: ['select-parent', 'move', 'delete', 'show-style-manager']
              },
              {
                name: 'OutputComp',
                droppable: false,
                resizable: true,
                content: '<div id="OutputComp"></div>',
                attributes: {
                  id: 'ip43'
                },
                commands: ['select-parent', 'move', 'delete', 'show-style-manager']
              },
              {
                name: 'ExeMatrix',
                droppable: false,
                resizable: true,
                content: '<div id="ExeMatrix"></div>',
                commands: ['select-parent', 'move', 'delete', 'show-style-manager']
              },
              {
                name: 'postToJdoodle',
                droppable: false,
                content: '<div id="postToJdoodle"></div>',
                attributes: {
                  id: 'ifxh-2'
                },
                commands: ['select-parent']
              }
            ]
          },
          id: 'xoZgGmJ4FsAJLaJd'
        }
      ],
      type: 'main',
      id: 'pFPYTappP6R3V506'
    }
  ]
}

export const HTML =
  '<body id="ieqb"><div><div id="fontSize"></div></div><div id="i5xj"><div id="IdeComp"></div></div><div id="iyal"><div id="VersionListComp"></div></div><div id="id4q"><div id="stdinArgs"></div></div><div><div id="inputArgs"></div></div><div><div id="interactiveToggle"></div></div><div id="i3ar"><div id="executeBtn"></div></div><div><div id="OutputComp"></div></div><div><div id="ExeMatrix"></div></div><div id="ifxh-2"><div id="postToJdoodle"></div></div></body>'
export const CSS =
  '* { box-sizing: border-box; } body {margin: 0;}@media (max-width: 1024px){#id4q{hideTitle:true;}#i3ar{color:black;}#i5xj{autoGrow:true;height:384px;}}'
export const JS = ''
